export class ApiError extends Error {
  status: number;

  constructor(message: string, status: number) {
    super(message);
    this.name = "ApiError";
    this.status = status;
  }
}

type PanelistNotFoundListener = () => void;

const panelistNotFoundListeners = new Set<PanelistNotFoundListener>();

export function isPanelistNotFoundError(error: unknown): error is ApiError {
  return (
    error instanceof ApiError &&
    error.message.toLowerCase().includes("panelist not found")
  );
}
export function notifyPanelistNotFound(error: unknown) {
  if (!isPanelistNotFoundError(error)) return;

  panelistNotFoundListeners.forEach((listener) => listener());
}

export function subscribeToPanelistNotFound(
  listener: PanelistNotFoundListener,
) {
  panelistNotFoundListeners.add(listener);
  return () => {
    panelistNotFoundListeners.delete(listener);
  };
}

const unauthorizedListeners = new Set<() => void>();
export function isUnauthorizedError(error: unknown): error is ApiError {
  return error instanceof ApiError && error.status === 401;
}
export function subscribeToUnauthorized(listener: () => void) {
  unauthorizedListeners.add(listener);
  return () => {
    unauthorizedListeners.delete(listener);
  };
}
export function notifyUnauthorized() {
  unauthorizedListeners.forEach((listener) => listener());
}
